<template>
  <div class="opening-hours">
    <template v-for="(openingHour, index) in openingHours.opening_hours">
      <v-opening-hour :opening-hour="openingHour" :key="openingHour.id"/>
      <br v-if="index === 1" :key="index"/>
    </template>
  </div>
</template>

<script>
export default {
  name: 'opening-hours',
  data() {
    return {
      showAnimation: false,
    };
  },
  methods: {
    isViewableNow(isVisible) {
      this.showAnimation = isVisible;
    },
  },
  props: {
    openingHours: {
      type: Object,
    },
  },
  components: {
    vOpeningHour: () => import('@/components/opening-hour'),
  },
};
</script>
